export default {
      id: "back-usage",
      viewBox: "0 0 17 11",
      url: __webpack_public_path__ + "app/svg/sprite.svg#back",
      toString: function () {
        return this.url;
      }
    }